import React from 'react';
import logout from '../Components/Image/logout.png'
import Sidebar from '../Components/Sidebar';
import { Table, InputGroup, FormControl } from 'react-bootstrap';
// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";
// To make rows collapsible
import "bootstrap/js/src/collapse.js";
import { useHistory, Link, Redirect } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


import { connect } from 'react-redux'
import { getQATemplates } from '../store/actions/qaTemplateActions'
import { getPODetails, inspectionDashboard, getPOSearch, getSearchedPO } from '../store/actions/poDetailsActions'
import { getDepartmentSearch } from '../store/actions/departmentActions'
import { getInspectionDetailsByInspectorID, getInspectionDetailsByInspectorIDForDashboard, postWaiveOffInspection, rejectHoldInspection } from '../store/actions/inspectionActions'
import { GetFilterList } from '../store/actions/masterActions'
import AuthHandlerInstance from '../Classes/AuthHandler'
import dateFormater from '../Classes/FormatDate'
// import { CSVLink } from "react-csv";
import SearchBar from '../Components/SearchBar'
import Select, { components } from "react-select"

import Modal from '../Components/CustomModal'
import ModalHeader from '../Components/ModalHeader'
import ModalBody from '../Components/ModalBody'
import ModalFooter from '../Components/ModalFooter'
import Loading from '../Components/Loader';
import DropdownFlat from '../Components/DropdownFlat';



class InspectionDashboard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            Inspectiontabledata: [{ "item": "item1" }, { "item": "item2" }, { "item": "item3" }],
            multiCollapseIndex: '',
            multiCollapseInspectionIndex: '',
            modal: false,
            opacity: "",
            waiveOffModalData: [],
            inspectionData: [],
            callsData: [],
            callsDataNew: [],
            inspectionDataNew: [],
            CSMTLink: '',
            csvData: [],
            csvItem: [],
            searchTerm: new URLSearchParams(this.props.location.search).get("searchTerm") ? new URLSearchParams(this.props.location.search).get("searchTerm") : "",
            totalPos: 0,
            // sortbyPo: new URLSearchParams(this.props.location.search).get("sortbyPo") ? (new URLSearchParams(this.props.location.search).get("sortbyPo")).split(',') : "",
            // vendor: new URLSearchParams(this.props.location.search).get("vendor") ? (new URLSearchParams(this.props.location.search).get("vendor")).split(',') : "",
            // inspectionLocation: new URLSearchParams(this.props.location.search).get("inspectionLocation") ? (new URLSearchParams(this.props.location.search).get("inspectionLocation")).split(',') : "",
            // status: new URLSearchParams(this.props.location.search).get("status") ? (new URLSearchParams(this.props.location.search).get("status")).split(',') : "",
            vendor: new URLSearchParams(this.props.location.search).get("vendor") ? new URLSearchParams(this.props.location.search).get("vendor") : "",
            sortbyPo: new URLSearchParams(this.props.location.search).get("sortbyPo") ? new URLSearchParams(this.props.location.search).get("sortbyPo") : "",
            inspectionLocation: new URLSearchParams(this.props.location.search).get("inspectionLocation") ? new URLSearchParams(this.props.location.search).get("inspectionLocation") : "",
            status: new URLSearchParams(this.props.location.search).get("status") ? new URLSearchParams(this.props.location.search).get("status") : "",
            searchForOptions: [
                {
                    label: 'PO Number', value: 'PO Number'
                },
                {
                    label: 'Vendor', value: 'Vendor'
                },
                {
                    label: 'Location', value: 'Location'
                },
                {
                    label: 'Status', value: 'Status'
                },
            ],
            searchForItem: new URLSearchParams(this.props.location.search).get("searchFor") ? [{
                label: new URLSearchParams(this.props.location.search).get("searchFor"), value: new URLSearchParams(this.props.location.search).get("searchFor")
            }] : [],
            searchFor: new URLSearchParams(this.props.location.search).get("searchFor") ? new URLSearchParams(this.props.location.search).get("searchFor") : "",
            sortByWBS: new URLSearchParams(this.props.location.search).get("sortByWBS") ? (new URLSearchParams(this.props.location.search).get("sortByWBS")).split(',') : [],
            sortByPlantCode: new URLSearchParams(this.props.location.search).get("sortByPlantCode") ? (new URLSearchParams(this.props.location.search).get("sortByPlantCode")).split(',') : [],
            sortByEmployees: new URLSearchParams(this.props.location.search).get("sortByEmployees") ? (new URLSearchParams(this.props.location.search).get("sortByEmployees")).split(',') : [],
            isShowFilter: false,
            sortByPo: [],
            sortByVendor: [],
            sortByVendorLocation: [],
            sortByInspectionLocation: [],
            finalpos: [],
            finalvendorlist: [],
            finalemployees: [],
            finalplantcode: [],
            finalwbsno: [],
            sortByEmployees: [],
            sortByPlantCode: [],
            sortByWBS: [],
            finalvendorlocation: [],
            finalfilter: [],
            rejectCallModal: false,
            Comment: "",
            loading: true,
            callId: "",
            inspectionTypes: [
                {
                    id: 0, name: "Stage",
                },
                {
                    id: 1, name: "Final",
                },
            ],
            inspectionType: ""
            
        }

        this.modal = this.modal.bind(this);
        this.rejectCallModal = this.rejectCallModal.bind(this);
        this.handleRowClick = this.handleRowClick.bind(this);


    }

    modal = async (call = null) => {
        var waiveOffModalData = []
        if (call) {
            waiveOffModalData.poNo = call.poNo
            // waiveOffModalData.poLineItemId = call.poLineItemId 
            waiveOffModalData.createdOn = call.createdOn
            waiveOffModalData.deliveryDate = call.deliveryDate
            waiveOffModalData.location = call.location
            waiveOffModalData.totalLineItemQuantity = call.totalLineItemQuantity
            waiveOffModalData.inspectionQuantity = call.inspectionQuantity
            waiveOffModalData.lineItemDescription = call.lineItemDescription
            waiveOffModalData.stageNameToInspect = call.QATemplateStageId == 0 ? "Final" : "Stage"
            waiveOffModalData.vendorName = call.vendorName
            waiveOffModalData.proposedDate = call.proposedDate
            waiveOffModalData.callNo = call.callNo
            waiveOffModalData.callId = call.callId
            waiveOffModalData.InspectionStatus = call.InspectionStatus
            console.log(waiveOffModalData, 'waiveoff')
            await this.setState({ waiveOffModalData })
            await this.setState({ inspectionType : call.QATemplateStageId == 0 ? "Final" : "Stage" })
        }
        await this.setState({ modal: !this.state.modal, template: "", templatedata: [], customStageDropdown: false });
        if (this.state.modal == true) {
            this.setState({ opacity: "" })

        } else {
            this.setState({ opacity: "" })

        }
    }

    handleRowInspectionClick = async (InspectionId) => {
        var multiCollapseInspectionIndex = this.state.multiCollapseInspectionIndex
        var waiveOffModalData = []
        var roles = AuthHandlerInstance.getRoles()
        if ((multiCollapseInspectionIndex != InspectionId || multiCollapseInspectionIndex == '')) {
            this.setState({ multiCollapseInspectionIndex: InspectionId, multiCollapseIndex: '' })
        }
    }

    handleRowClick = (callId) => {
        var multiCollapseIndex = this.state.multiCollapseIndex
        if ((multiCollapseIndex != callId || multiCollapseIndex == '')) {
            this.setState({ multiCollapseIndex: callId, multiCollapseInspectionIndex: '' })
        }
    }

    waiveOff = async (callId) => {
        let UserId = AuthHandlerInstance.getUserID()
        await this.props.postWaiveOffInspection(callId, {
            UserId: UserId,
            CallIdData: callId,
            CSMTLink: this.state.CSMTLink,
            poNo: this.state.waiveOffModalData.poNo,
            inspectionType: this.state.inspectionType,
        })
        await this.setState({ CSMTLink: '' })
        await this.modal()
        await this.dataSync()
    }

    // clearFilter = async () => {
    //     await this.setState({
    //         sortbyPo: '',
    //         searchTerm: '',
    //         vendor: '',
    //         inspectionLocation: '',
    //         status: '',
    //         searchFor: '',
    //         searchForItem: [],
    //     })
    //     await this.dataSync()
    // }

    dataSync = async () => {
        await this.setState({ loading: true })
        const form = {
            //  POId: req.params.id,
            PurchaseOrderLineId: 'req.params.lineid',
            QATemplateName: 'req.body.template',
            TemplateId: 'req.body.TemplateId',
            SeqNo: 'req.body.SeqNo',
            StageId: 'req.body.StageId'
        }

        var roles = AuthHandlerInstance.getRoles()
        var userId = AuthHandlerInstance.getUserID()
        let callsData = []
        let inspectionData = []
        let csvData = []
        let csvItem = []
        let newcall = []
        let inspectionAllocate = []
        let inspectionRejected = []
        let inspectionAccepted = []
        let inspectionWaiveOff = []
        let newcall1 = []
        let inspectionAllocate1 = []
        let inspectionRejected1 = []
        let inspectionAccepted1 = []
        let inspectionWaiveOff1 = []
        let callsDataNew = []
        let inspectionDataNew = []

        // let searchData = {
        //     sortbyPo: this.state.sortbyPo,
        //     vendor: this.state.vendor,
        //     inspectionLocation: this.state.inspectionLocation,
        //     status: this.state.status,
        //     sortByEmployees: this.state.sortByEmployees,
        //     sortByPlantCode: this.state.sortByPlantCode,
        //     sortByWBS: this.state.sortByWBS,
        //     searchTerm: this.state.searchTerm,
        //     searchFor: this.state.searchFor
        // }
        // this.props.history.push({
        //     pathname: '/InspectionDashboard',
        //     search: "?" + new URLSearchParams(searchData).toString()
        // })
        // if (roles[3]) {
        //     await this.props.getInspectionDetailsByInspectorID(userId, searchData)
        //     if (this.props.inspectionReducer && this.props.inspectionReducer.inspectionDetailsByInspectorId) {
        //         let insdata = await this.props.inspectionReducer.inspectionDetailsByInspectorId
        //         for (let i = 0; i < insdata.length; i++) {
        //             await inspectionData.push(insdata[i])
        //         }
        //     }

        // }
        // await this.props.getInspectionDetailsByInspectorID(0, searchData)
        // if (this.props.inspectionReducer && this.props.inspectionReducer.inspectionDetailsByInspectorId) {
        //     let data = await this.props.inspectionReducer.inspectionDetailsByInspectorId
        //     for (let i = 0; i < data.length; i++) {
        //         await callsData.push(data[i])
        //     }
        // }
        await this.handleSearching()
        await inspectionData.map(async (value) => {
            await csvData.push({
                'Call No.': value.callNo,
                'Call Date': value.RaisedOn && value.RaisedOn !== null ? dateFormater(value.RaisedOn) : '',
                'PO Number': value.poNo,
                'PO Item': value.poLineItemNo,
                'WBSCode': value.WBSCode,
                'Proposed Date': value.proposedDate ? dateFormater(value.proposedDate) : '',
                'Status': value.LineItemstatus,
                'Offered Quantity': value.inspectionQuantity + " " + value.Unit,
                'Accepted Quantity': value.AcceptedQuantity && value.AcceptedQuantity !== null ? value.AcceptedQuantity + " " + value.Unit : 0 + " " + value.Unit,
                'Pending Quantity': value.PendingQuantity && value.PendingQuantity !== null ? value.PendingQuantity + " " + value.Unit : 0 + " " + value.Unit,
                'Rework Reoffer Quantity': value.ReworkReofferQty && value.ReworkReofferQty !== null ? value.ReworkReofferQty + " " + value.Unit : 0 + " " + value.Unit,
                'Rejected Quantity': value.RejectedQuantity && value.RejectedQuantity !== null ? value.RejectedQuantity + " " + value.Unit : 0 + " " + value.Unit,
                'Supplier Not Ready Quantity': value.SupplierNotReadyQty && value.SupplierNotReadyQty !== null ? value.SupplierNotReadyQty + " " + value.Unit : 0 + " " + value.Unit,
                'Rework Compliance Quantity': value.ReworkComplainceQty && value.ReworkComplainceQty !== null ? value.ReworkComplainceQty + " " + value.Unit : 0 + " " + value.Unit,
                'Inspection Not Completed': value.InspectionNotCompletedQty && value.InspectionNotCompletedQty !== null ? value.InspectionNotCompletedQty + " " + value.Unit : 0 + " " + value.Unit,
            })
        })
        // if(userId)
        // await this.props.getInspectionDetailsByInspectorID(0, searchData)
        // if (this.props.inspectionReducer && this.props.inspectionReducer.inspectionDetailsByInspectorId) {
        //     let data = await this.props.inspectionReducer.inspectionDetailsByInspectorId
        //     for (let i = 0; i < data.length; i++) {
        //         await callsData.push(data[i])
        //     }
        // }
        // console.log('callsData', callsData)

        // newcall1 = inspectionData.filter(element => (element.InspectionStatus == null && element.LineItemstatus == null) || (element.InspectionStatus == null && element.LineItemstatus == ""))
        // inspectionAllocate1 = inspectionData.filter(element => element.InspectionStatus === 'Inspector Allocated')
        // inspectionRejected1 = inspectionData.filter(element => element.InspectionStatus === 'Inspection Request Rejected')
        // inspectionAccepted1 = inspectionData.filter(element => element.InspectionStatus === 'Inspection Request Accepted')
        // inspectionWaiveOff1 = inspectionData.filter(element => element.LineItemstatus === 'Inspection has waived off')
        // console.log('newcall1', newcall1)
        // console.log('inspectionAllocate1', inspectionAllocate1)
        // console.log('inspectionRejected1', inspectionRejected1)
        // console.log('inspectionAccepted1', inspectionAccepted1)
        // console.log('inspectionWaiveOff1', inspectionWaiveOff1)

        // await newcall1.map(async (element) => {
        //     await inspectionDataNew.push(element)
        // })
        // await inspectionAllocate1.map(async (element) => {
        //     await inspectionDataNew.push(element)
        // })
        // await inspectionRejected1.map(async (element) => {
        //     await inspectionDataNew.push(element)
        // })
        // await inspectionAccepted1.map(async (element) => {
        //     await inspectionDataNew.push(element)
        // })
        // await inspectionWaiveOff1.map(async (element) => {
        //     await inspectionDataNew.push(element)
        // })
        // // console.log('inspectionDataNew--', inspectionDataNew)

        // newcall = callsData.filter(element => (element.InspectionStatus == null && element.LineItemstatus == null) || (element.InspectionStatus == null && element.LineItemstatus == ""))
        // inspectionAllocate = callsData.filter(element => element.InspectionStatus === 'Inspector Allocated')
        // inspectionRejected = callsData.filter(element => element.InspectionStatus === 'Inspection Request Rejected')
        // inspectionAccepted = callsData.filter(element => element.InspectionStatus === 'Inspection Request Accepted')
        // inspectionWaiveOff = callsData.filter(element => element.LineItemstatus === 'Inspection has waived off')
        // console.log('newcall', newcall)
        // console.log('inspectionAllocate', inspectionAllocate)
        // console.log('inspectionRejected', inspectionRejected)
        // console.log('inspectionAccepted', inspectionAccepted)
        // console.log('inspectionWaiveOff', inspectionWaiveOff)

        // await newcall.map(async (element) => {
        //     await callsDataNew.push(element)
        // })
        // await inspectionAllocate.map(async (element) => {
        //     await callsDataNew.push(element)
        // })
        // await inspectionRejected.map(async (element) => {
        //     await callsDataNew.push(element)
        // })
        // await inspectionAccepted.map(async (element) => {
        //     await callsDataNew.push(element)
        // })
        // await inspectionWaiveOff.map(async (element) => {
        //     await callsDataNew.push(element)
        // })
        // console.log('callsDataNew--', callsDataNew)


        // await inspectionData.map(async (value) => {
        //     await csvData.push({
        //         'Call No.': value.callNo,
        //         'Call Date': value.RaisedOn && value.RaisedOn !== null ? dateFormater(value.RaisedOn) : '',
        //         'PO Number': value.poNo,
        //         'PO Item': value.poLineItemNo,
        //         'WBSCode': value.WBSCode,
        //         'Proposed Date': value.proposedDate ? dateFormater(value.proposedDate) : '',
        //         'Status': value.LineItemstatus,
        //         'Offered Quantity': value.inspectionQuantity + " " + value.Unit,
        //         'Accepted Quantity': value.AcceptedQuantity && value.AcceptedQuantity !== null ? value.AcceptedQuantity + " " + value.Unit : 0 + " " + value.Unit,
        //         'Pending Quantity': value.PendingQuantity && value.PendingQuantity !== null ? value.PendingQuantity + " " + value.Unit : 0 + " " + value.Unit,
        //         'Rework Reoffer Quantity': value.ReworkReofferQty && value.ReworkReofferQty !== null ? value.ReworkReofferQty + " " + value.Unit : 0 + " " + value.Unit,
        //         'Rejected Quantity': value.RejectedQuantity && value.RejectedQuantity !== null ? value.RejectedQuantity + " " + value.Unit : 0 + " " + value.Unit,
        //         'Supplier Not Ready Quantity': value.SupplierNotReadyQty && value.SupplierNotReadyQty !== null ? value.SupplierNotReadyQty + " " + value.Unit : 0 + " " + value.Unit,
        //         'Rework Compliance Quantity': value.ReworkComplainceQty && value.ReworkComplainceQty !== null ? value.ReworkComplainceQty + " " + value.Unit : 0 + " " + value.Unit,
        //         'Inspection Not Completed': value.InspectionNotCompletedQty && value.InspectionNotCompletedQty !== null ? value.InspectionNotCompletedQty + " " + value.Unit : 0 + " " + value.Unit,
        //     })
        // })
        // await callsData.map(async (value) => {
        //     await csvItem.push({
        //         "callsData": value.callId,
        //         "Vendor": value.vendorName,
        //         "WBS": value.WBSCode,
        //         "PO Number": value.poNo,
        //         "Line Item No.": value.poLineItemNo,
        //         "Item Description": value.lineItemDescription,
        //         "Requested Date": dateFormater(value.proposedDate),
        //         "Inspection Location": value.InspectionLocation ? value.InspectionLocation : "---",
        //         "Inspection Date": value.InspectionDate ? dateFormater(value.InspectionDate) : "---",
        //         "Status": value.HasWaivedOff ? 'Inspection has waived off' : value.CallItemType == 'RW' && !value.InspectionStatus ? 'Rework Call' : !value.InspectionStatus ? 'New Call' : value.InspectionStatus,
        //         "Location": value.location,
        //         "Inspector": value.InspectorName ? value.InspectorName : '--',
        //         "Rejection Reason": value.LineItemstatus == 'Inspection has Rejected' ? value.Field01 ? value.Field01 : '---' : value.RejectionReason ? value.RejectionReason : '--',
        //         "Next Planned Date": value.NextPlannedDate ? dateFormater(value.NextPlannedDate) : '--'
        //     })
        // })
        await this.setState({ csvData, csvItem, loading: false })
        await this.getFilterList()
    }
    componentDidMount = async () => {
        await this.dataSync()
        // await this.handleSearching()
    }

    handleCSMTLink(e) {
        this.setState({ CSMTLink: e.target.value })
    }
    handleISearch = (e) => {
        let searchTerm = e.target.value
        if (this.state.searchFor == 'Vendor') {
            this.setState({ vendor: searchTerm })
        }
        else if (this.state.searchFor == 'PO Number') {
            this.setState({ sortbyPo: searchTerm })
        }
        else if (this.state.searchFor == 'Location') {
            this.setState({ inspectionLocation: searchTerm })
        }
        else if (this.state.searchFor == 'Status') {
            this.setState({ status: searchTerm })
        }
        this.setState({
            searchTerm
        })
        console.log(this.state.searchTerm, "asd")
    }
    handleSearching = async () => {
        var roles = AuthHandlerInstance.getRoles()
        var userId = AuthHandlerInstance.getUserID()
        await this.setState({ loading: true })
        let inspectionDataNew = []
        let callsDataNew = []
        let searchData = {
            sortbyPo: this.state.sortbyPo,
            vendor: this.state.vendor,
            inspectionLocation: this.state.inspectionLocation,
            status: this.state.status,
            searchTerm: this.state.searchTerm,
            searchFor: this.state.searchFor,
            sortByPo: this.state.sortByPo,
            sortByVendor: this.state.sortByVendor,
            sortByVendorLocation: this.state.sortByVendorLocation,
            sortByEmployees: this.state.sortByEmployees,
            sortByPlantCode: this.state.sortByPlantCode,
            sortByWBS: this.state.sortByWBS,
            sortByInspectionLocation: this.state.sortByInspectionLocation,
        }
        console.log(searchData, "searchData====>")
        this.props.history.push({
            pathname: '/InspectionDashboard',
            search: "?" + new URLSearchParams(searchData).toString()
        })
        if (roles[3]) {
            // await this.props.getInspectionDetailsByInspectorID(userId, searchData)
            // if (this.props.inspectionReducer && this.props.inspectionReducer.inspectionDetailsByInspectorId) {
            //     let insdata = await this.props.inspectionReducer.inspectionDetailsByInspectorId
            //     console.log(insdata, "insdata-->")
            //     for (let i = 0; i < insdata.length; i++) {
            //         await inspectionDataNew.push(insdata[i])
            //     }
            // }
            await this.props.getInspectionDetailsByInspectorIDForDashboard(userId, searchData)
            if (this.props.inspectionReducer && this.props.inspectionReducer.inspectionDetailsByInspectorIdforDashboard) {
                let insdata = await this.props.inspectionReducer.inspectionDetailsByInspectorIdforDashboard
                console.log(insdata, "insdata-->")
                for (let i = 0; i < insdata.length; i++) {
                    await inspectionDataNew.push(insdata[i])
                }
            }
        }

        await this.props.getInspectionDetailsByInspectorIDForDashboard(0, searchData)
        if (this.props.inspectionReducer && this.props.inspectionReducer.inspectionDetailsByInspectorIdforDashboard) {
            let data = await this.props.inspectionReducer.inspectionDetailsByInspectorIdforDashboard
            console.log(data, "insdata-->")
            for (let i = 0; i < data.length; i++) {
                await callsDataNew.push(data[i])
            }
        }
        await this.setState({ inspectionDataNew, callsDataNew, loading: false })
    }
    handleSelectSearchFor = async (value) => {
        let searchFor = value
        let searchForItem = [
            {
                label: value, value: value
            }
        ]
        await this.setState({ searchFor, searchForItem })
    }
    toggleFilter = async () => {
        this.setState({ isShowFilter: !this.state.isShowFilter })
    }
    clearFilter = async () => {
        await this.setState({
            isShowFilter: false,
            sortByPo: [],
            sortByVendor: [],
            sortByVendorLocation: [],
            sortByEmployees: [],
            sortByPlantCode: [],
            sortByWBS: [],
            searchFor: '',
            searchTerm: '',
            POSAPId: [],
            VendorName: [],
            VendorLocation: [],
            InspectionLocation: [],
            sortByInspectionLocation: [],
        })
        await this.handleSearching()
    }
    handleSelectPO = async (e) => {
        let sortByPo = []
        let POSAPId = []
        if (e.length > 0) {
            e.map((item) => {
                sortByPo.push(item.value)
                POSAPId.push(item)
            })
        }
        await this.setState({ sortByPo, POSAPId })
        await this.handleSearching()
    }
    handleSelectVendor = async (e) => {
        let sortByVendor = []
        let VendorName = []
        console.log(e, "HHHH")
        if (e.length > 0) {
            e.map((item) => {
                sortByVendor.push(item.value)
                VendorName.push(item)
            })
        }
        await this.setState({ sortByVendor, VendorName })
        await this.handleSearching()
    }
    handleSelectWBS = async (e) => {
        let sortByWBS = []
        let WBSCode = []
        if (e.length > 0) {
            e.map((item) => {
                sortByWBS.push(item.value)
                WBSCode.push(item)
                return item
            })
        }
        await this.setState({ sortByWBS, WBSCode })
        await this.handleSearching()
    }

    handleSelectEmployees = async (e) => {
        let sortByEmployees = []
        let sortBy = 'all'
        let employees = []
        if (e.length > 0) {
            e.map((item) => {
                if (item.value !== 'opened') {
                    sortByEmployees.push(item.value)
                } else {
                    sortBy = 'opened'
                }
                employees.push(item)
                return item
            })
        }
        await this.setState({ sortByEmployees, employees, sortBy })
        await this.handleSearching()
    }

    handleSelectPlantCode = async (e) => {
        let sortByPlantCode = []
        let PlantCode = []
        if (e.length > 0) {
            e.map((item) => {
                sortByPlantCode.push(item.value)
                PlantCode.push(item)
                return item
            })
        }
        await this.setState({ sortByPlantCode, PlantCode })
        await this.handleSearching()
    }
    handleSelectVendorLocation = async (e) => {
        let sortByVendorLocation = []
        let VendorLocation = []
        console.log(e, "HHHH")
        if (e.length > 0) {
            e.map((item) => {
                sortByVendorLocation.push(item.value)
                VendorLocation.push(item)
            })
        }
        await this.setState({ sortByVendorLocation, VendorLocation })
        await this.handleSearching()
    }
    handleSelectInspectionLocation = async (e) => {
        let sortByInspectionLocation = []
        let InspectionLocation = []
        console.log(e, "HHHH")
        if (e.length > 0) {
            e.map((item) => {
                sortByInspectionLocation.push(item.value)
                InspectionLocation.push(item)
            })
        }
        await this.setState({ sortByInspectionLocation, InspectionLocation })
        await this.handleSearching()
    }

    getFilterList = async () => {
        await this.props.GetFilterList()
        console.log(this.props.filterList, 'filterList')

        let finalvendorlist = []
        let finalpos = []
        let finalvendorlocation = []
        let finalemployees = []
        let finalwbsno = []
        let finalplantcode = []
        let finalfilter = []
        await finalfilter.push({ label: `Open`, value: 'opened' })
        await this.props.filterList[3].map(async (item) => {
            await finalvendorlist.push({ label: item.VendorName, value: item.VendorName })
        })
        await finalemployees.push({ label: `Open`, value: 'opened' })
        await this.props.filterList[5].map(async (item) => {
            await finalemployees.push({ label: `${item.EmployeeName}`, value: item.EmployeeName })
        })
        await this.props.filterList[1].map(async (item) => {
            await finalplantcode.push({ label: item.PlantCode, value: item.PlantCode })
        })
        await this.props.filterList[2].map(async (item) => {
            await finalwbsno.push({ label: (item.WBSCode), value: (item.WBSCode) })
        })
        await this.props.filterList[4].map(async (item) => {
            await finalpos.push({ label: item.POSAPId, value: item.POSAPId })
        })
        await this.props.filterList[16].map(async (item) => {
            await finalvendorlocation.push({ label: item.VendorLocation, value: item.VendorLocation })
        })
        await this.props.filterList[16].map(async (item) => {
            await finalvendorlocation.push({ label: item.InspectionLocation, value: item.InspectionLocation })
        })
        let POSAPId = []
        let VendorName = []
        let VendorLocation = []
        let InspectionLocation = []
        let employees = []
        let PlantCode = []
        let WBSCode = []
        await this.state.sortByPo.map(async (item) => {
            await POSAPId.push({ label: item, value: item })
        })
        await this.state.sortByVendor.map(async (item) => {
            await VendorName.push({ label: item, value: item })
        })
        await this.state.sortByVendorLocation.map(async (item) => {
            await VendorLocation.push({ label: item, value: item })
        })
        await this.state.sortByInspectionLocation.map(async (item) => {
            await InspectionLocation.push({ label: item, value: item })
        })
        await this.state.sortByPlantCode.map(async (item) => {
            await PlantCode.push({ label: item, value: item })
        })
        await this.state.sortByWBS.map(async (item) => {
            await WBSCode.push({ label: item, value: item })
        })
        await this.state.sortByEmployees.map(async (item) => {
            await employees.push({ label: item, value: item })
        })
        await this.setState({ finalfilter, finalvendorlist, finalpos, finalvendorlocation, finalemployees, finalplantcode, finalwbsno, POSAPId, VendorName, VendorLocation, employees, WBSCode, PlantCode, InspectionLocation })
    }
    rejectCallModal(callId = 0) {
        this.setState({ rejectCallModal: !this.state.rejectCallModal, callId });
        // if (this.state.rejectCallModal == true) {
        //     this.setState({ opacity: "" })

        // } else {
        //     this.setState({ opacity: "0.2" })

        // }
    }
    handleComment(e) {
        let input = e.target.value
        this.setState({ Comment: input })
    }
    rejectCall = async (callId) => {
        let input = {
            Comment: this.state.Comment,
            callId: this.state.callId
        }
        await this.props.rejectHoldInspection(input)

        console.log('reject', input)
        await this.rejectCallModal()
        await this.dataSync()
    }
    holdInspection = async (callId) => {
        let input = {
            Comment: '',
            callId: callId,
            status: 'Hold',
        }
        await this.props.rejectHoldInspection(input)
        await this.dataSync()
    }

    handleInspectionTypeChange = (e, index) => {
        this.setState({ inspectionType : e.target.value })
    }

    render() {
        console.log("lkhjgwdsa", this.state.callsDataNew)
        let inspectiondata1 = []
        let inspectiondata2 = []
        let inspectiondata3 = []
        let inspectiondata4 = []
        let inspectiondata5 = []
        let inspectiondata6 = []
        let inspectiondata7 = []
        this.state.callsDataNew.map((item, index) => {
            if (item.HasWaivedOff === null && item.CallItemType !== 'RW' && item.InspectionStatus === null) {
                inspectiondata1.push(item)
            }
            else if (item.HasWaivedOff === null && item.CallItemType !== 'RW' && item.InspectionStatus === 'Inspection Request Rejected') {
                inspectiondata2.push(item)
            }
            else if (item.HasWaivedOff === null && item.CallItemType !== 'RW' && item.InspectionStatus === 'Inspection Request Accepted') {
                inspectiondata3.push(item)
            }
            else if (item.HasWaivedOff === null && item.CallItemType !== 'RW' && item.InspectionStatus === 'Inspector Re-Allocated') {
                inspectiondata5.push(item)
            }
            else if (item.HasWaivedOff === null && item.CallItemType !== 'RW' && item.InspectionStatus === 'Inspector Allocated') {
                inspectiondata6.push(item)
            }
            else if (item.HasWaivedOff) {
                inspectiondata7.push(item)
            }
        })
        let inspectiondata = [...inspectiondata1, ...inspectiondata2, ...inspectiondata3, ...inspectiondata4, ...inspectiondata5, ...inspectiondata6, ...inspectiondata7];

        console.log("fewdvfwdsd ", inspectiondata1)
        const { qaTemplate } = this.props.qaTemplate
        var permissions = AuthHandlerInstance.getPermissions()
        var roles = AuthHandlerInstance.getRoles()

        console.log(this.state.inspectionData, "insp=======")
        console.log(this.state.callsData, "calls======")
        console.log(permissions, "permissions")
        console.log(roles, 'roles')
        console.log(AuthHandlerInstance.getUserPayLoad())
        const inspectionDetailsByInspectorId = []
        const inspectionDetailsByInspectorIdforDashboard = []
        const inspectionByMe = []
        const waiveOffinspectionDetailsByInspectorIdData = []
        this.props.inspectionReducer && this.props.inspectionReducer.inspectionDetailsByInspectorIdforDashboard.map((value, index) => {
            console.log('lineitem : ', value.LineItem)
            if (roles[3] && permissions[7]) {
                if (value.HasWaivedOff == true) {
                    waiveOffinspectionDetailsByInspectorIdData.push(value)
                } else {
                    inspectionDetailsByInspectorIdforDashboard.push(value)
                }
                if (value.IsAccepted && value.InspectorId == AuthHandlerInstance.getUserID()) {
                    var exist = inspectionByMe.findIndex((element) => element.InspectionId === value.InspectionId)
                    if (exist === -1) {
                        inspectionByMe.push(value)
                    }
                }
            } else if (roles[3]) {
                if (value.IsAccepted) {
                    var exist = inspectionByMe.findIndex((element) => element.InspectionId === value.InspectionId)
                    if (exist === -1) {
                        inspectionByMe.push(value)
                    }
                }
            } else if (roles[6]) {
                if (value.HasWaivedOff == true) {
                    waiveOffinspectionDetailsByInspectorIdData.push(value)
                } else {
                    inspectionDetailsByInspectorIdforDashboard.push(value)
                }
            }
            else {
                if (value.HasWaivedOff == true) {
                    waiveOffinspectionDetailsByInspectorIdData.push(value)
                } else {
                    inspectionDetailsByInspectorIdforDashboard.push(value)
                }
            }

            // })
        })
        const customStyles = {
            option: (provided, state) => ({
                ...provided,
                borderBottom: '1px dotted pink',
                //   color: state.isSelected ? 'red' : 'blue',
                padding: "2px 10px",
            }),
            menu: (provided, state) => ({
                ...provided,
                width: "100%",
                minWidth: "max-content",
                zIndex: "999 !important",
            }),
        }
        console.log('&&&&&&&&&&&7', inspectionDetailsByInspectorIdforDashboard)
        console.log("RRRRRRR", this.state.waiveOffModalData)
        return (

            <div className="Container-fluid p-4 " style={{ 'height': '100vh' }}>

                <Modal isOpen={this.state.modal} className="modal-xl">
                    <ModalHeader HeaderStyle="modal-header">
                        <h4 style={{ color: 'black', textAlign: ' center', verticalAlign: 'middle' }}>Waive Off Inspection</h4>
                        <button type="button" className="close" aria-label="Close" onClick={() => this.modal()} style={{ color: 'black' }}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </ModalHeader>
                    <ModalBody Style="modal-body">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-4">
                                    PO Number
                                </div>
                                <div className="col-md-2 font-weight-bold">
                                    {this.state.waiveOffModalData.poNo}
                                </div>

                                <div className="col-md-4">
                                    PO Item
                                </div>
                                <div className="col-md-2 font-weight-bold ">
                                    {this.state.waiveOffModalData.poLineItemId}
                                </div>

                                <div className="col-md-2">
                                    PO Date
                                </div>
                                <div className="col-md-4 font-weight-bold">
                                    {dateFormater(this.state.waiveOffModalData.createdOn)}
                                </div>

                                <div className="col-md-2">
                                    PO Delivery Date
                                </div>
                                <div className="col-md-4 font-weight-bold">
                                    {dateFormater(this.state.waiveOffModalData.deliveryDate)}
                                </div>

                                <div className="col-md-2">
                                    Supplier Name
                                </div>
                                <div className="col-md-4 font-weight-bold">
                                    {this.state.waiveOffModalData.vendorName}
                                </div>

                                <div className="col-md-2">
                                    Total PO Quantity
                                </div>
                                <div className="col-md-4 font-weight-bold">
                                    {this.state.waiveOffModalData.totalLineItemQuantity}
                                </div>

                                <div className="col-md-2">
                                    Inspection Quantity
                                </div>
                                <div className="col-md-4 font-weight-bold ">
                                    {this.state.waiveOffModalData.inspectionQuantity}
                                </div>

                                <div className="col-md-2">
                                    Item Description
                                </div>
                                <div className="col-md-4 font-weight-bold">
                                    {this.state.waiveOffModalData.lineItemDescription}
                                </div>

                                <div className="col-md-2">
                                    Stage \ Final
                                </div>
                                <div className="col-md-4 font-weight-bold">
                                    <DropdownFlat defaultopt="Select Type" data={this.state.inspectionTypes} selectedValue={this.state.inspectionType} actions={(e) => { this.handleInspectionTypeChange(e) }} keyObjName={"name"} valueObjName={"name"} />
                                </div>

                                <div className="col-md-2">
                                    Location
                                </div>
                                <div className="col-md-4 font-weight-bold">
                                    {this.state.waiveOffModalData.location}
                                </div>

                                <div className="col-md-2">
                                    Prposed Date
                                </div>
                                <div className="col-md-4 font-weight-bold">
                                    {dateFormater(this.state.waiveOffModalData.proposedDate)}
                                </div>

                                <div className="col-md-2">
                                    Status
                                </div>
                                <div className="col-md-4 font-weight-bold">
                                    {this.state.waiveOffModalData.InspectionStatus}
                                </div>

                                <div className="col-md-2">
                                    CSMT Link (Optional)
                                </div>
                                <div className="col-md-4 font-weight-bold">
                                    <input name="csmtlink" placeholder="Enter CSMT Link" value={this.state.CSMTLink} onChange={(e) => { this.handleCSMTLink(e) }} />
                                </div>
                            </div>
                        </div>

                    </ModalBody>
                    <ModalFooter FooterStyle="modal-footer ">
                        <div className="container-fluid  ">
                            <div className='row'>
                                <div className='col float-right'>
                                    <button type="button" className="btn2 btn-sms1 rounded-pill mt-2 float-right" onClick={() => this.modal()}> Cancel </button>
                                    <button type="button" className="btn2 btn-sms1 rounded-pill mt-2  float-right" onClick={() => this.waiveOff(this.state.waiveOffModalData.callId)}>Waive Off Inspection </button>
                                </div>
                            </div>
                        </div>
                    </ModalFooter>

                </Modal>
                <Modal isOpen={this.state.rejectCallModal} className="modal-lg">
                    <ModalHeader HeaderStyle="modal-header">
                        <h4 style={{ color: 'black', textAlign: ' center', verticalAlign: 'middle' }}>Rejected Call</h4>
                        <button type="button" className="close" aria-label="Close" onClick={this.rejectCallModal} style={{ color: 'black' }}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </ModalHeader>
                    <ModalBody Style="modal-body">
                        <div className="col-md-5"><b>Comment :</b></div>
                        <div className="col-md-7">
                            <input type="text" className="form-control" value={this.state.Comment} onChange={(e) => this.handleComment(e)}></input>
                        </div>

                    </ModalBody>
                    <ModalFooter FooterStyle="modal-footer ">
                        <div className="container-fluid  ">
                            <div className='row'>
                                <div className='col float-right'>
                                    <button type="button" className="btn2 btn-sms1 rounded-pill mt-2 float-right" onClick={this.rejectCallModal}> Cancel </button>
                                    <button type="button" className="btn2 btn-sms1 rounded-pill mt-2  float-right" onClick={() => this.rejectCall()}>Reject Call</button>
                                </div>
                            </div>
                        </div>
                    </ModalFooter>

                </Modal>


                <div className="Container-fluid " style={{ opacity: this.state.opacity }}>
                    <div className="row">
                        <div className="col-md-3">
                            <p className='header'>
                                <b>Inspection Dashboard</b>
                            </p>
                        </div>
                        {
                            roles[3] ?
                                <div className="col-md-3">
                                    <Link to={{ pathname: '/NewInspections', state: {} }}>
                                        <button className="btn2 btn-sms1 rounded-pill mr-4 float-right" type="submit">New Inspections</button>
                                    </Link>
                                </div>
                                : null
                        }

                        {/* <div className='col-md-4'>
                            {roles[3] ?
                                <CSVLink className="btn2 btn-sms1 float-right rounded-pill" data={this.state.csvData} filename={'Inspections'}>export</CSVLink>
                                : null}
                            {permissions[7] ?
                                <CSVLink className="btn2 btn-sms1 float-right rounded-pill" data={this.state.csvItem} filename={'Inspections'}>export</CSVLink>
                                : null
                            }
                        </div> */}
                    </div >
                    <div className=" pt-2 xs={last}" style={{ marginLeft: "855px", marginRight: "40px" }}>
                        <SearchBar placeholder="Search" value={this.state.searchTerm} searchInputHandler={(e) => { this.handleISearch(e) }} searchClick={this.handleSearching} label="Search" btnName="" ShowSearchFor={true} searchForOptions={this.state.searchForOptions} searchForItem={this.state.searchForItem} SelectSearchForHandler={this.handleSelectSearchFor} toggleFilter={this.toggleFilter} clearFilter={this.clearFilter} filter={true} clear={true} />
                    </div>
                    {
                        this.state.isShowFilter ?
                            <div className="row justify-content-between pb-3 pt-3 m-0 border-radius-modal border-color filter-data pr-2 pl-2">
                                <div className="col">
                                    <Select maxMenuHeight={500} placeholder="Vendor" isMulti value={this.state.VendorName} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalvendorlist} onChange={(e) => this.handleSelectVendor(e)} />
                                </div>
                                <div className="col">
                                    <Select maxMenuHeight={500} placeholder="PO No." isMulti value={this.state.POSAPId} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalpos} onChange={(e) => this.handleSelectPO(e)} />
                                </div>
                                <div className="col">
                                    <Select maxMenuHeight={500} placeholder="Planner" isMulti value={this.state.employees} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalemployees} onChange={(e) => this.handleSelectEmployees(e)} />
                                </div>
                                <div className="col">
                                    <Select maxMenuHeight={500} placeholder="Project Code" isMulti value={this.state.WBSCode} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalwbsno} onChange={(e) => this.handleSelectWBS(e)} />
                                </div>
                                <div className="col">
                                    <Select maxMenuHeight={500} placeholder="Plant" isMulti value={this.state.PlantCode} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalplantcode} onChange={(e) => this.handleSelectPlantCode(e)} />
                                </div>
                                <div className="col">
                                    <Select maxMenuHeight={500} placeholder="InspectionLocation" isMulti value={this.state.InspectionLocation} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalvendorlocation} onChange={(e) => this.handleSelectInspectionLocation(e)} />
                                </div>
                                <div className="col">
                                    <Select maxMenuHeight={500} placeholder="Vendor Location" isMulti value={this.state.VendorLocation} mode="multiple" hideSelectedOptions={false} closeMenuOnSelect={false} tabSelectsValue={false} controlShouldRenderValue={false} styles={customStyles} options={this.state.finalvendorlocation} onChange={(e) => this.handleSelectVendorLocation(e)} />
                                </div>
                            </div>
                            : null
                    }


                    <div className="row  pl-2 pr-4">
                        {
                            roles[3] && permissions[7] ?
                                <>
                                    <div className="col-12 pr-4">
                                        <h4>QA Planner Inspections</h4>
                                        <hr />
                                    </div>
                                    <div className="col-md-12 centre-alligned wrap">
                                        <div className="row sticky headerbar-treasury" >
                                            <div className="col-md-1 pt-2 pb-2 borderheaderbar">Call ID</div>
                                            <div className="col pt-2 pb-2 borderheaderbar">Vendor</div>
                                            <div className="col pt-2 pb-2 borderheaderbar">PO Number</div>
                                            <div className="col pt-2 pb-2 borderheaderbar ">Requested Date</div>
                                            <div className="col pt-2 pb-2 borderheaderbar">Vendor Location</div>
                                            <div className="col pt-2 pb-2 borderheaderbar">Inspection Location</div>
                                            <div className="col pt-2 pb-2 borderheaderbar">Inspection Date</div>
                                            <div className="col pt-2 pb-2 borderheaderbar">Status</div>
                                            <div className="col pt-2 pb-2 borderheaderbar ">Action</div>
                                        </div>
                                        {
                                            inspectionDetailsByInspectorIdforDashboard == '' || inspectionDetailsByInspectorIdforDashboard.length == 0 ? <div className="row justify-content-center">No inspection calls found</div> : null
                                        }
                                        {this.state.loading ?
                                            <Loading />
                                            :
                                            this.state.callsDataNew.map((value, index) => (
                                                <div key={index}>
                                                    <div className={value.HasWaivedOff ? 'row  backgroundwaiveOff' : index % 2 == 0 ? 'row border ' : 'row  background '} onClick={() => this.handleRowClick(value.callId)} data-toggle="collapse" data-target={`.multi-collapse${value.callId}`}>
                                                        <div className="col-md-1 pt-2 pb-2 borderheaderbar">{value.callId}</div>
                                                        <div className="col-md-1 pt-2 pb-2 borderheaderbar">{value.WBSCode ? (value.WBSCode.includes('ET') ? (value.WBSCode).slice(0, 11) : (value.WBSCode).slice(0, 6)) : ''}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar">{value.vendorName}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar ">{value.poNo}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar">{dateFormater(value.proposedDate)}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar ellipsis">{value.location ? value.location : "---"}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar ellipsis">{value.InspectionLocation ? value.InspectionLocation : "---"}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar ellipsis">{value.InspectionDate ? dateFormater(value.InspectionDate) : "---"}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar ">{value.HasWaivedOff ? 'Inspection has waived off' : value.CallItemType == 'RW' && !value.InspectionStatus ? 'Rework Call' : !value.InspectionStatus ? 'New Call' : value.InspectionStatus}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar ">
                                                            <div className='row justify-content-center'>
                                                                <div className='col text-center'>
                                                                    {value.LineItemstatus !== 'Inspection has Rejected' ?
                                                                        <>
                                                                            {
                                                                                !value.HasWaivedOff && !value.IsAccepted && value.Rejected == null ?
                                                                                    permissions[9] ?
                                                                                        <FontAwesomeIcon className="align-middle pr-2 ml-2" icon={"user-times"} color={"black"} title="Waive Off" size="2x" onClick={() => this.modal(value)} style={{ width: "2rem" }} />
                                                                                        : null
                                                                                    : null
                                                                            }
                                                                            {
                                                                                !value.HasWaivedOff && !value.InspectionId ?
                                                                                    permissions[7] || roles[1] ?
                                                                                        <Link to={{ pathname: '/AllocateInspector', state: { callId: value.callId, InspectionId: value.InspectionId } }}><FontAwesomeIcon className="align-middle pr-2 ml-2" icon={"user-check"} color={"black"} title="Allocate Inspector" size="2x" style={{ width: "2rem" }} /></Link>
                                                                                        : null
                                                                                    : !value.HasWaivedOff && !value.IsAccepted && value.InspectionStatus === 'Inspection Request Rejected' && value.Rejected == null ?
                                                                                        <Link to={{ pathname: '/AllocateInspector', state: { callId: value.callId, InspectionId: value.InspectionId } }}><FontAwesomeIcon className="align-middle pr-2 ml-2" icon={"user-check"} color={"black"} title="Allocate Inspector" size="2x" style={{ width: "2rem" }} /></Link>
                                                                                        : null
                                                                            }
                                                                            {
                                                                                !value.HasWaivedOff && value.InspectionId && !value.IsAccepted && value.InspectionStatus !== 'Inspection Request Rejected' ?
                                                                                    permissions[7] || roles[1] ?
                                                                                        <Link to={{ pathname: '/AllocateInspector', state: { callId: value.callId, InspectionId: value.InspectionId } }}><FontAwesomeIcon className="align-middle pr-2 ml-2" icon={"user-edit"} color={"black"} title="Edit Inspection" size="2x" style={{ width: "2rem" }} /></Link>
                                                                                        : null
                                                                                    : null
                                                                            }
                                                                        </>
                                                                        : null}
                                                                    <Link to={{ pathname: '/InspectionDashboard_lineItem', state: { poNo: value.poNo, poLine: value.LineItem, callId: value.callId } }}> <FontAwesomeIcon icon={"eye"} color={"black"} title="View" size="lg" style={{ width: "2rem" }} /></Link>
                                                                    {!value.HasWaivedOff && !value.InspectionId && value.LineItemstatus !== 'Inspection has Rejected' && permissions[7] ? <FontAwesomeIcon className="align-middle pr-2 ml-2" icon={"user-slash"} color={"black"} style={{ cursor: 'pointer', width: "2rem" }} title="Reject" size="2x" onClick={() => this.rejectCallModal(value.callId)} /> : null}
                                                                    {value.LineItemstatus == 'Inspection has Rejected' ? <div className='badge badge-danger' style={{ display: "block" }}>Inspection Request <br /> Rejected</div>
                                                                        : value.LineItemstatus == 'Inspection on Hold' ? <span className='badge badge-warning'>Inspection on Hold</span> : null}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={value.callId == this.state.multiCollapseIndex ? `container collapse multi-collapse${value.callId}` : `container collapse`} style={{ background: '#ddd', border: '1px solid' }}>
                                                        <div className="row">
                                                            <div className="col-md-2 ">
                                                                <b>Location :</b>
                                                            </div>
                                                            <div className="col-md-4">
                                                                {value.location}
                                                            </div>
                                                            <div className="col-md-2 ">
                                                                <b>Inspector:</b>
                                                            </div>
                                                            <div className="col-md-4">
                                                                {value.InspectorName ? value.InspectorName : '--'}
                                                            </div>
                                                            <div className="col-md-2 ">
                                                                <b>Rejection Reason :</b>
                                                            </div>
                                                            <div className="col-md-4">
                                                                {value.LineItemstatus == 'Inspection has Rejected' ? value.Field01 ? value.Field01 : '---' : value.RejectionReason ? value.RejectionReason : '--'}
                                                            </div>
                                                            <div className="col-md-2 ">
                                                                <b>Next Planned Date :</b>
                                                            </div>
                                                            <div className="col-md-4">
                                                                {value.NextPlannedDate ? dateFormater(value.NextPlannedDate) : '--'}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div >
                                            ))
                                        }
                                        <hr />
                                    </div >

                                    {/* Inspections List For ME */}
                                    < div className="col-12 pr-4" >
                                        <h4>Inspector Inspections</h4>
                                        <hr />
                                    </div >
                                    <div className="col-md-12 centre-alligned wrap">
                                        <div className="row sticky headerbar-treasury" >
                                            <div className="col-md-1 pt-2 pb-2 borderheaderbar">Inspection ID</div>
                                            <div className="col pt-2 pb-2 borderheaderbar">Vendor</div>
                                            <div className="col-md-1 pt-2 pb-2 borderheaderbar">Project Number</div>
                                            <div className="col pt-2 pb-2 borderheaderbar">PO Number</div>
                                            <div className="col pt-2 pb-2 borderheaderbar ">Inspection Date</div>
                                            <div className="col pt-2 pb-2 borderheaderbar">Vendor Location</div>
                                            <div className="col pt-2 pb-2 borderheaderbar">Inspection Location</div>
                                            <div className="col pt-2 pb-2 borderheaderbar">Status</div>
                                            <div className="col pt-2 pb-2 borderheaderbar ">Action</div>
                                        </div>
                                        {
                                            inspectionByMe == '' && this.state.inspectionDataNew.length === 0 ? <div className="row justify-content-center">No inspection found</div> : null
                                        }

                                        {
                                            this.state.inspectionDataNew.map((value, index) => (

                                                <div key={index}>

                                                    <div className={value.HasWaivedOff ? 'row  backgroundwaiveOff' : index % 2 == 0 ? 'row border ' : 'row  background '} onClick={() => this.handleRowInspectionClick(value.InspectionId)} data-toggle="collapse" data-target={`.multi-collapse${value.InspectionId}`}>
                                                        <div className="col-md-1 pt-2 pb-2 borderheaderbar">{value.InspectionId}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar">{value.vendorName}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar">{value.WBSCode ? (value.WBSCode.includes('ET') ? (value.WBSCode).slice(0, 11) : (value.WBSCode).slice(0, 6)) : ''}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar ">{value.poNo}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar">{dateFormater(value.InspectionStartDate)}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar ellipsis">{value.location}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar ellipsis">{value.InspectionLocation}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar ellipsis">{value.InspectionStatus}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar ">
                                                            <div className='row justify-content-center text-center'>

                                                                <div className='col'>
                                                                    <Link to={{ pathname: '/InspectionDashboard_lineItem', state: { poNo: value.poNo, poLine: value.LineItem, InspectionId: value.InspectionId } }}> <FontAwesomeIcon icon={"eye"} color={"black"} title="View" size="lx" /></Link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={value.InspectionId == this.state.multiCollapseInspectionIndex ? `container collapse multi-collapse${value.InspectionId}` : `container collapse`}>
                                                        <div className="row">
                                                            <div className="col-md-2 ">
                                                                <b>Location :</b>
                                                            </div>
                                                            <div className="col-md-4">
                                                                {value.location}
                                                            </div>
                                                            <div className="col-md-2 ">
                                                                <b>PO Date:</b>
                                                            </div>
                                                            <div className="col-md-2">
                                                                {dateFormater(value.createdOn)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                            ))
                                        }
                                    </div>
                                </>
                                : roles[3] ?
                                    <div className="col-md-12 centre-alligned wrap">
                                        <div className="row sticky headerbar-treasury" >
                                            <div className="col-md-1 pt-2 pb-2 borderheaderbar">Inspection ID</div>
                                            <div className="col-md-1 pt-2 pb-2 borderheaderbar">Project Number</div>
                                            <div className="col pt-2 pb-2 borderheaderbar">Vendor</div>
                                            <div className="col pt-2 pb-2 borderheaderbar">PO Number</div>
                                            <div className="col pt-2 pb-2 borderheaderbar ">Inspection Date</div>
                                            <div className="col pt-2 pb-2 borderheaderbar">Vendor Location</div>
                                            <div className="col pt-2 pb-2 borderheaderbar">Inspection Location</div>
                                            <div className="col pt-2 pb-2 borderheaderbar">Status</div>
                                            <div className="col pt-2 pb-2 borderheaderbar ">Action</div>
                                        </div>
                                        {
                                            inspectionByMe == '' && this.state.inspectionDataNew.length === 0 ? <div className="row justify-content-center">No inspection found</div> : null
                                        }

                                        {this.state.loading ?
                                            <Loading />
                                            :
                                            this.state.inspectionDataNew.map((value, index) => (

                                                <div key={index}>

                                                    <div className={value.HasWaivedOff ? 'row  backgroundwaiveOff' : index % 2 == 0 ? 'row border ' : 'row  background '} onClick={() => this.handleRowInspectionClick(value.InspectionId)} data-toggle="collapse" data-target={`.multi-collapse${value.InspectionId}`}>
                                                        <div className="col-md-1 pt-2 pb-2 borderheaderbar">{value.InspectionId}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar">{value.WBSCode ? (value.WBSCode.includes('ET') ? (value.WBSCode).slice(0, 11) : (value.WBSCode).slice(0, 6)) : ''}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar">{value.vendorName}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar ">{value.poNo}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar">{dateFormater(value.InspectionStartDate)}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar ellipsis">{value.location}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar ellipsis">{value.InspectionLocation}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar ellipsis">{value.InspectionStatus}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar ">
                                                            <div className='row justify-content-center'>

                                                                <div className='col'>
                                                                    <Link to={{ pathname: '/InspectionDashboard_lineItem', state: { poNo: value.poNo, poLine: value.LineItem, InspectionId: value.InspectionId } }}> <FontAwesomeIcon icon={"eye"} color={"black"} title="View" size="lx" /></Link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={value.InspectionId == this.state.multiCollapseInspectionIndex ? `container collapse multi-collapse${value.InspectionId}` : `container collapse`}>
                                                        <div className="row">
                                                            <div className="col-md-2 ">
                                                                <b>Location :</b>
                                                            </div>
                                                            <div className="col-md-4">
                                                                {value.location}
                                                            </div>
                                                            <div className="col-md-2 ">
                                                                <b>PO Date:</b>
                                                            </div>
                                                            <div className="col-md-2">
                                                                {dateFormater(value.createdOn)}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                            ))
                                        }
                                    </div >
                                    :
                                    <div className="col pr-4 wrap">
                                        <div className="row sticky headerbar-treasury " >
                                            <div className="col-md-1 pt-2 pb-2 borderheaderbar">Call ID</div>
                                            <div className="col pt-2 pb-2 borderheaderbar">Vendor</div>
                                            <div className="col pt-2 pb-2 borderheaderbar">Project Number</div>
                                            <div className="col pt-2 pb-2 borderheaderbar">PO Number</div>
                                            <div className="col pt-2 pb-2 borderheaderbar ">Requested Date</div>
                                            <div className="col pt-2 pb-2 borderheaderbar">Vendor Location</div>
                                            <div className="col pt-2 pb-2 borderheaderbar">Inspection Location</div>
                                            <div className="col pt-2 pb-2 borderheaderbar">Inspection Date</div>
                                            <div className="col pt-2 pb-2 borderheaderbar">Status</div>
                                            <div className="col pt-2 pb-2 borderheaderbar ">Action</div>
                                        </div>
                                        {
                                            inspectionDetailsByInspectorIdforDashboard == '' && inspectionDetailsByInspectorIdforDashboard.length == 0 && inspectiondata.length === 0 ? <div className="row justify-content-center">No inspection calls found</div> : null
                                        }

                                        {this.state.loading ?
                                            <Loading />
                                            :
                                            inspectiondata.length > 0 && inspectiondata.map((value, index) => (

                                                <div key={index}>

                                                    <div className={value.HasWaivedOff ? 'row  backgroundwaiveOff' : index % 2 == 0 ? 'row border ' : 'row  background '} onClick={() => this.handleRowClick(value.callId)} data-toggle="collapse" data-target={`.multi-collapse${value.callId}`}>
                                                        <div className="col-md-1 pt-2 pb-2 borderheaderbar">{value.callId}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar">{value.vendorName}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar">{value.WBSCode ? (value.WBSCode.includes('ET') ? (value.WBSCode).slice(0, 11) : (value.WBSCode).slice(0, 6)) : ''}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar ">{value.poNo}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar">{dateFormater(value.proposedDate)}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar ellipsis">{value.location ? value.location : "---"}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar ellipsis">{value.InspectionLocation ? value.InspectionLocation : "---"}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar ellipsis">{value.InspectionDate ? dateFormater(value.InspectionDate) : "---"}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar ">{value.HasWaivedOff ? 'Inspection has waived off' : value.CallItemType == 'RW' && !value.InspectionStatus ? 'Rework Call' : !value.InspectionStatus ? 'New Call' : value.InspectionStatus}</div>
                                                        <div className="col pt-2 pb-2 borderheaderbar ">
                                                            <div className='row justify-content-center'>

                                                                <div className='col text-center'>
                                                                    {value.LineItemstatus !== 'Inspection has Rejected' ?
                                                                        <>
                                                                            {
                                                                                !value.HasWaivedOff && !value.IsAccepted && (value.InspectionStatus === 'Inspection Request Rejected' || value.InspectionStatus == null) && value.Rejected == null ?
                                                                                    permissions[9] ?
                                                                                        <FontAwesomeIcon className="align-middle pr-2 ml-2" icon={"user-times"} color={"black"} title="Waive Off" size="2x" onClick={() => this.modal(value)} />
                                                                                        : null
                                                                                    : null
                                                                            }
                                                                            {
                                                                                !value.HasWaivedOff && !value.InspectionId ?
                                                                                    permissions[7] ?
                                                                                        <Link to={{ pathname: '/AllocateInspector', state: { callId: value.callId, InspectionId: value.InspectionId } }}><FontAwesomeIcon className="align-middle pr-2 ml-2" icon={"user-check"} color={"black"} title="Allocate Inspector" size="2x" /></Link>
                                                                                        : null
                                                                                    : !value.HasWaivedOff && !value.IsAccepted && value.InspectionStatus === 'Inspection Request Rejected' && value.Rejected == null ?
                                                                                        <Link to={{ pathname: '/AllocateInspector', state: { callId: value.callId, InspectionId: value.InspectionId } }}><FontAwesomeIcon className="align-middle pr-2 ml-2" icon={"user-check"} color={"black"} title="Allocate Inspector" size="2x" /></Link>
                                                                                        : null
                                                                            }
                                                                            {
                                                                                !value.HasWaivedOff && value.InspectionId && !value.IsAccepted && value.InspectionStatus !== 'Inspection Request Rejected' ?
                                                                                    permissions[7] ?
                                                                                        <Link to={{ pathname: '/AllocateInspector', state: { callId: value.callId, InspectionId: value.InspectionId } }}><FontAwesomeIcon className="align-middle pr-2 ml-2" icon={"user-edit"} color={"black"} title="Edit Inspection" size="2x" /></Link>
                                                                                        : null
                                                                                    : null
                                                                            }
                                                                        </>
                                                                        : null}
                                                                    <Link to={{ pathname: '/InspectionDashboard_lineItem', state: { poNo: value.poNo, poLine: value.LineItem, callId: value.callId } }}> <FontAwesomeIcon icon={"eye"} color={"black"} title="View" size="lg" /></Link>
                                                                    {!value.HasWaivedOff && !value.InspectionId && value.LineItemstatus !== 'Inspection has Rejected' && permissions[7] ? <FontAwesomeIcon className="align-middle pr-2 ml-2" icon={"user-slash"} color={"black"} style={{ cursor: 'pointer' }} title="Reject" size="2x" onClick={() => this.rejectCallModal(value.callId)} /> : null}
                                                                    {value.LineItemstatus == 'Inspection has Rejected' ? <div className='badge badge-danger' style={{ display: "block" }}>Inspection Request <br /> Rejected</div>
                                                                        : value.LineItemstatus == 'Inspection on Hold' ? <span className='badge badge-warning'>Inspection on Hold</span> : null}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={value.callId == this.state.multiCollapseIndex ? `container collapse multi-collapse${value.callId}` : `container collapse`} style={{ background: '#ddd', border: '1px solid' }}>
                                                        <div className="row">
                                                            <div className="col-md-2 ">
                                                                <b>Location :</b>
                                                            </div>
                                                            <div className="col-md-4">
                                                                {value.location}
                                                            </div>
                                                            <div className="col-md-2 ">
                                                                <b>Inspector:</b>
                                                            </div>
                                                            <div className="col-md-4">
                                                                {value.InspectorName ? value.InspectorName : '--'}
                                                            </div>
                                                            <div className="col-md-2 ">
                                                                <b>Rejection Reason :</b>
                                                            </div>
                                                            <div className="col-md-4">
                                                                {value.LineItemstatus == 'Inspection has Rejected' ? value.Field01 ? value.Field01 : '---' : value.RejectionReason ? value.RejectionReason : '--'}
                                                            </div>
                                                            <div className="col-md-2 ">
                                                                <b>Next Planned Date :</b>
                                                            </div>
                                                            <div className="col-md-4">
                                                                {value.NextPlannedDate ? dateFormater(value.NextPlannedDate) : '--'}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                            ))
                                        }



                                    </div >
                        }
                    </div>
                </div >
            </div >
        )
    }
}

const mapStateToProps = (state) => ({ qaTemplate: state.qaTemplate, poDetails: state.poDetails, departmentSearch: state.departmentSearchReducer, inspectionReducer: state.inspectionReducer, filterList: state.masterReducer.filterList })
export default connect(mapStateToProps, { getQATemplates, getPODetails, getDepartmentSearch, getPOSearch, getSearchedPO, inspectionDashboard, getInspectionDetailsByInspectorID, getInspectionDetailsByInspectorIDForDashboard, postWaiveOffInspection, GetFilterList, rejectHoldInspection })(InspectionDashboard)




